<div fxLayout="row" style='height: 100%; background-color: white; margin-top: 100px;'>
  <div fxFlex.md="33.333"></div>

  <div fxFlex.md="33.333" sm-center>
    <mat-icon>
      refresh
    </mat-icon>
    <br />
    <br />
    {{ 'ERROR.LOAD_PROBLEM' | translate }}
    <br/>
    <br/>
    {{ 'ERROR.TAP_TO_RETRY' | translate }}
  </div>

  <div fxFlex.md="33.333"></div>
</div>
